import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const ExpandableDescription = ({
  text,
  maxLength = 50,
  textClassName = "text-gray-900",
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useTranslation();

  if (!text) return null;

  const isLong = text.length > maxLength;

  return (
    <div className="whitespace-normal break-words pr-2">
      <span className={textClassName}>
        {isExpanded || !isLong ? text : `${text.substring(0, maxLength)}...`}
      </span>
      {isLong && (
        <button
          type="button"
          className="block mt-1 text-xs text-blue-600 hover:text-blue-500 font-medium text-left"
          onClick={(e) => {
            e.stopPropagation();
            setIsExpanded(!isExpanded);
          }}
        >
          {isExpanded ? t("Show less") : t("Read more")}
        </button>
      )}
    </div>
  );
};

export default ExpandableDescription;
